"use client";

import { useEffect, useState } from "react";
import "../mpact2026.css";

const TARGET_TIME = new Date("2026-09-25T00:00:00+05:30").getTime();

function pad(n: number) {
  return n < 10 ? `0${n}` : `${n}`;
}

type Remaining = { days: number; hours: number; mins: number; secs: number };

function getRemaining(): Remaining {
  const diff = TARGET_TIME - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, mins: 0, secs: 0 };
  const totalSecs = Math.floor(diff / 1000);
  const days = Math.floor(totalSecs / 86400);
  const hours = Math.floor((totalSecs % 86400) / 3600);
  const mins = Math.floor((totalSecs % 3600) / 60);
  const secs = totalSecs % 60;
  return { days, hours, mins, secs };
}

const Countdown = () => {
  // Starts as `null` (instead of computing from Date.now() up front) so the
  // server-rendered markup and the client's first render match exactly. The
  // real value is filled in after mount, avoiding a hydration mismatch.
  const [remaining, setRemaining] = useState<Remaining | null>(null);

  useEffect(() => {
    setRemaining(getRemaining());
    const interval = setInterval(() => setRemaining(getRemaining()), 1000);
    return () => clearInterval(interval);
  }, []);

  const display = remaining ?? { days: 0, hours: 0, mins: 0, secs: 0 };

  return (
    <div className="mpact-heroCountdown mpact-rise mpact-d7">
      <p className="mpact-heroCountdownLabel">
        <span className="mpact-liveDot" aria-hidden="true" />
        Counting down to M-PACT 2026
      </p>
      <div className="mpact-cdRow">
        <div className="mpact-cdItem">
          <span>{pad(display.days)}</span>
          <small>Days</small>
        </div>
        <div className="mpact-cdItem">
          <span>{pad(display.hours)}</span>
          <small>Hours</small>
        </div>
        <div className="mpact-cdItem">
          <span>{pad(display.mins)}</span>
          <small>Mins</small>
        </div>
        <div className="mpact-cdItem">
          <span>{pad(display.secs)}</span>
          <small>Secs</small>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
